import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import PhotoGallery from "@/components/base/PhotoGallery";
import type { StoryPost } from "@/mocks/stories";

export default function StoryArticleGallery({ story }: { story: StoryPost }) {
  if (!story.gallery.length) return null;

  return (
    <section className="sun-glaze bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-8 md:mb-12">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              From the Field
            </span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl leading-tight text-foreground-950 font-semibold">
            Photographs From This Story
          </h2>
          <p className="mt-4 text-base text-foreground-600 leading-relaxed">
            Tap any photo to open it full screen and move through the collection.
          </p>
        </Reveal>

        <Reveal delay={100}>
          <PhotoGallery images={story.gallery} layout="strip" />
        </Reveal>
      </div>
    </section>
  );
}